/**
 * Recurrence utility functions
 */

/**
 * Generate a human-readable label for a recurrence pattern
 * @param {Object} recurrence - Recurrence object with type and interval
 * @returns {string} Localized recurrence label
 */
export function getRecurrenceLabel(recurrence) {
  if (!recurrence) return 'Unbekannt';

  const { type, interval } = recurrence;

  switch (type) {
    case 'daily':
      return 'Täglich';
    case 'weekly':
      return interval === 1 ? 'Wöchentlich' : `Alle ${interval} Wochen`;
    case 'monthly':
      return interval === 1 ? 'Monatlich' : `Alle ${interval} Monate`;
    default:
      return 'Unbekannt';
  }
}
